import { render } from "./Gamelist.vue?vue&type=template&id=e8be0904&ts=true"
import script from "./Gamelist.vue?vue&type=script&lang=ts"
export * from "./Gamelist.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__